<template>
  <div class="chart">
    <div class="chart-grid">
      <h2 class="chart-title">{{ $t('text.collection') }}</h2>
      <h2 class="chart-title">{{ $t('text.disbursement') }}</h2>
      <CreatedByChannelChart :id="PAYMENT_TYPE_ID_COLLECTION" />
      <CreatedByChannelChart :id="PAYMENT_TYPE_ID_PAYMENT" />
      <CreatedByMerchantChart :id="PAYMENT_TYPE_ID_COLLECTION" />
      <CreatedByMerchantChart :id="PAYMENT_TYPE_ID_PAYMENT" />
    </div>
  </div>
</template>

<script>
import CreatedByChannelChart from "./CreatedByChannelChart.vue";
import CreatedByMerchantChart from "./CreatedByMerchantChart.vue";
import {
  PAYMENT_TYPE_ID_COLLECTION,
  PAYMENT_TYPE_ID_PAYMENT
} from "../../utils/Constant";

export default {
  components: { CreatedByChannelChart, CreatedByMerchantChart },
  data() {
    return {
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT
    };
  }
};
</script>

<style scoped lang="scss">
.chart {
  background: white;
  overflow-x: auto;
  padding: 0 1.5rem;
}

.chart-grid {
  display: grid;
  grid-template-columns: repeat(2, 70dvw);
  grid-template-rows: auto 1fr 1fr auto;
  grid-column-gap: 5rem;
  grid-row-gap: 3.5rem;
}

.chart-title {
  font-size: 2.5rem;
  text-align: center;
}
</style>
